
      function getAbsoluteUrl(relativeUrl) {
        const publicPath = __webpack_public_path__;

        let url = '';

        if (!publicPath || publicPath.indexOf('://') < 0) {
          url += window.location.protocol + '//' + window.location.host;
        }

        if (publicPath) {
          url += publicPath;
        } else {
          url += '/';
        }

        return url + relativeUrl;
      }
// Copyright 2017-2021 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
// For esm, this should be ({ url: getAbsoluteUrl('node_modules/@polkadot/util/detectPackage.js') }).url or to get the same behavior as __dirname, we can use
//
//   new URL(({ url: getAbsoluteUrl('node_modules/@polkadot/util/detectPackage.js') }).url).pathname)
//
// The issue is the WP4 has "some" issues with ({ url: getAbsoluteUrl('node_modules/@polkadot/util/detectPackage.js') }).url. So because of bundlers, we can't have
// nice things... In this case it is even worse since ({ url: getAbsoluteUrl('node_modules/@polkadot/util/detectPackage.js') }).url won't even make it compile, so
// there is a complete dead end with usage thereof
//
// When that is fixed, a solution is to have both .js & .mjs files, with the following content -
//
// cjs: util.detectPackage(packageInfo, () => __dirname);
// esm: detectPackage(packageInfo, () => ({ url: getAbsoluteUrl('node_modules/@polkadot/util/detectPackage.js') }).url);
//
// With the above we additionally need a .d.ts to just export the packageInfo
import { packageInfo as decoderInfo } from '@polkadot/x-textdecoder';
import { packageInfo as encoderInfo } from '@polkadot/x-textencoder';
import { packageInfo } from "./packageInfo.js";
import { detectPackage } from "./versionDetect.js";
detectPackage(packageInfo, typeof __dirname !== 'undefined' && __dirname, [decoderInfo, encoderInfo]);